import { setClassName } from '@change-corgi/core/error';

import { PageDataError } from '#src/shared/error';

import type { PsfPromoteOrShareDataQuery } from '../api.graphql';
import type { PsfPromoteOrShareRecruiterQuery } from '../recruiter.graphql';

export type PsfPromoteOrSharePageDataErrorCode =
	| 'psf_promote_or_share_page_data_not_found'
	| 'psf_promote_or_share_page_missing_promotion_stats';
export class PsfPromoteOrSharePageDataError extends PageDataError<PsfPromoteOrSharePageDataErrorCode> {}
setClassName(PsfPromoteOrSharePageDataError, 'PsfPromoteOrSharePageDataError');

export type Recruiter = PsfPromoteOrShareRecruiterQuery['recruiter'];
export type Petition = NonNullable<PsfPromoteOrShareDataQuery['petition']>;
export type Viewer = PsfPromoteOrShareDataQuery['viewer'];
export type Bandits = Petition['bandits'];
export type PromotionStats = NonNullable<Petition['promotionStats']>;

export type FcmValues = PsfPromoteOrShareDataQuery['featureConfigs'];

export type HeroFeedItem = NonNullable<PsfPromoteOrShareDataQuery['petition']>['feeds']['heroFeed'][0];

type Experiments = PsfPromoteOrShareDataQuery['viewer']['experiments'];
export type PromoteShareOnComboExperiment = Experiments['promoteShareOnComboExperiment'];
export type PsfComboRemoveAutoProgressionExperiment = Experiments['psfComboRemoveAutoProgressionExperiment'];

export type PsfPromoteOrSharePageData = {
	petition: Omit<Petition, 'bandits' | 'headlineBandits' | 'promotionStats' | 'tagsConnection'> & {
		promotionStats: NonNullable<NonNullable<PsfPromoteOrShareDataQuery['petition']>['promotionStats']>;
		categoryTags: string[];
	};
	recruiter?: Recruiter;
	bandits: {
		psfCombo: Omit<Bandits['psfComboStandalone'], 'id' | 'variants'> & {
			comboExpVariant?: string;
			overridden: boolean;
		};
	};
	chipInAmount: number;
	chipInAmountLocalized: string;
	joinTheCommunityCustomConfig?: {
		promoterCount: number;
		promoterCountLocalized: string;
		contributionAmount: number;
		contributionAmountLocalized: string;
		additionalSignatures: number;
		additionalSignaturesLocalized: string;
	};
	promotionGoal: number;
	promotionGoalLocalized: string;
	hideRecruiterEnabled: boolean;
	isShareSlideUpEnabled: boolean;
	isShareAssetsEnabled: boolean;
	whatsappHeadlineExperiment: {
		variation: 'control' | 'variant1' | 'variant2' | 'variant3' | 'variant4' | 'fake_control';
		name: string;
		variants: Partial<
			Readonly<
				Record<
					'variant1' | 'variant2' | 'variant3' | 'variant4' | 'fake_control',
					Readonly<{
						message: string;
					}>
				>
			>
		>;
	};
	signaturesFromShareCountEstimateLocalized: string;
	useDonationLanguage: boolean;
	advocateEntryPointButtonLabel: string;
	advocateEntryPointExperiment: {
		variation: Experiments['advocateEntryPoint']['variation'];
		name: string;
	};
	advocateEntryPointCpDisabled: boolean;
	promoteShareOnComboExperiment: {
		variation: Experiments['promoteShareOnComboExperiment']['variation'];
	};
	psfComboRemoveAutoProgressionExperiment: PsfComboRemoveAutoProgressionExperiment;
	revenueLongerComboCopyExperiment: {
		variation: Experiments['revenueLongerComboCopyExperiment']['variation'];
	};
	// Raw data for PromoteForm normalization - avoids circular dependency
	promoteFormRawData?: {
		viewer: Viewer;
		featureConfigs: FcmValues;
	};
};
